<ng-template #productForm>
  <div>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modalClose()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ !this.selectedProduct ? ("MENU.CREATE_PRODUCT" | translate) : ("MENU.EDIT_PRODUCT" | translate) }}</h3>
      <div class="row" [formGroup]="formGroup">
        <div class="form-group col-12">
          <label for="name">{{ "NAME" | translate }}:<sup class="text-danger">*</sup></label>
          <input id="name" type="text" class="form-control {{ formHasError('name') ? 'is-invalid' : null }}" formControlName="name" />
          <div class="invalid-feedback" *ngIf="formGroup.controls.name.errors?.required">{{ "ERRORS.INSERT_NAME" | translate }}</div>
        </div>
        <div class="form-group col-12">
          <label for="monthly_cost">{{ "PRESUMED_TOTAL_MONTHLY_COST" | translate }}:<sup class="text-danger">*</sup></label>
          <input id="monthly_cost" placeholder="3.000,00" type="text" class="form-control {{ formHasError('monthly_cost') ? 'is-invalid' : null }}" formControlName="monthly_cost" (change)="formatMoneyValue('cost')" />
          <div class="invalid-feedback" *ngIf="formGroup.controls.monthly_cost.errors?.required">{{ "ERRORS.INSERT_MONTHLY_COST" | translate }}</div>
        </div>
        <div class="form-group col-12">
          <label for="monthly_amount">{{ "MONTHLY_IMPORT" | translate }}:<sup class="text-danger">*</sup></label>
          <input
            id="monthly_amount"
            placeholder="3.000,00"
            type="text"
            class="form-control {{ formHasError('monthly_amount') ? 'is-invalid' : null }}"
            formControlName="monthly_amount"
            (change)="formatMoneyValue('amount')"
          />
          <div class="invalid-feedback" *ngIf="formGroup.controls.monthly_amount.errors?.required">{{ "ERRORS.INSERT_MONTHLY_AMOUNT" | translate }}</div>
        </div>
        <div class="form-group col-12">
          <label for="description">{{ "DESCRIPTION" | translate }}</label>
          <textarea id="description" [placeholder]="'DESCRIPTION' | translate" type="text" class="form-control {{ formHasError('description') ? 'is-invalid' : null }}" formControlName="description"></textarea>
          <div class="invalid-feedback" *ngIf="formGroup.controls?.description.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
        </div>
        <div class="col-12 form-group">
          <div class="row">
            <div class="col-12">
              <label for="attachment">{{ "FILE" | translate }}:</label>
              <div id="attachment-uploader" class="custom-file">
                <input class="custom-file-input" type="file" lang="it" id="attachment" [multiple]="true" (change)="addAttachmentToList($any($event).target.files)" accept="application/pdf" />
                <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="!selectedProduct || !selectedProduct.attachments || (selectedProduct && selectedProduct.attachments && selectedProduct.attachments.length < 1)">
            <div class="col-12">{{ "NO_ONE_DOCUMENT_UPLOADED" | translate }}</div>
          </div>
          <div class="row" *ngIf="selectedProduct && selectedProduct.attachments && selectedProduct.attachments.length > 0">
            <div class="col-12 d-flex align-items-center" *ngFor="let file of selectedProduct.attachments">
              <span class="badge badge-warning cursor-pointer mr-025" [ngbTooltip]="'VIEW' | translate" (click)="_utilService.getFile(file.url)"
                ><span class="mr-025" [data-feather]="'file-text'" size="16"></span>{{ file?.filename }}</span
              >
              <button type="button" class="btn border-0 px-0 text-danger" [ngbTooltip]="'DELETE' | translate" (click)="deleteAttachment(file.id)">
                <span [data-feather]="'trash-2'" size="16"></span>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-1">
              <div class="d-flex align-items-center justify-content-between">
                <div *ngIf="attachments_list_obj.length > 0">
                  <button class="btn btn-outline-danger" (click)="resetAttachmentsList()">{{ "RESET" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3 border-top pt-1" *ngIf="attachments_list_obj.length > 0">
              <div *ngFor="let file of attachments_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1">
                <div class="flex-basis-60 d-flex align-items-center">
                  <div class="mr-05 cursor-pointer" (click)="removeAttachmentFromList(i)" *ngIf="file.status === 0">
                    <i [data-feather]="'x'" class="text-danger" size="18"></i>
                  </div>
                  <div class="mt-025">{{ file.name }}</div>
                </div>
                <div class="flex-basis-20 text-right">{{ file.size }}</div>
              </div>
              <div>{{ "TOTAL" | translate }}: {{ attachments_list_obj.length }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()">{{ "CANCEL" | translate }}</button>
      <button (click)="!selectedProduct ? createProduct() : editProduct()" type="submit" class="btn btn-primary w-150">{{ "SEND" | translate }}</button>
    </div>
  </div>
</ng-template>
